import { CheckCircleIcon } from "./icons";

export const MIGRATION_STEPS = [
  "Wallet",
  "Kelayakan",
  "Izin Token",
  "Migrasi",
  "Bukti",
] as const;

/**
 * The five stages, as one horizontal rail above the card.
 *
 * `current` is the stage the card is showing; everything before it counts as
 * done. The rail is a `<nav>` of list items rather than links because none of
 * these stages is navigable — the chain decides which one the wallet is on.
 */
export function StepBar({ current }: { current: number }) {
  return (
    <nav className="step-bar-wrap" aria-label="Tahapan migrasi">
      <ol className="step-bar">
        {MIGRATION_STEPS.map((label, index) => {
          const step = index + 1;
          const state = step < current ? "done" : step === current ? "current" : "todo";

          return (
            <li key={label} className="contents">
              <span
                className={`step-bar__item step-bar__item--${state}`}
                aria-current={state === "current" ? "step" : undefined}
              >
                {state === "done" ? (
                  <span className="step-bar__mark">
                    <CheckCircleIcon size={14} />
                  </span>
                ) : null}
                {step}. {label}
              </span>
              {step < MIGRATION_STEPS.length ? (
                <span className="step-bar__separator" aria-hidden>
                  ›
                </span>
              ) : null}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
